/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SelectTransferOptionRequest} from '@cash-web/protos/squareup/franklin/app/select_transfer_option.pb'
import {SelectTransferOptionResponse} from '@cash-web/protos/squareup/franklin/app/select_transfer_option.pb'


export const selectTransferOption = (request: SelectTransferOptionRequest, options?: CashRequestOptions) => post<SelectTransferOptionRequest, SelectTransferOptionResponse>("/2.0/cash/select-transfer-option", request, {...options, rejectOnError: true })